<template src="./template.html"></template>

<!-- start JS -->
<script>
    /* eslint-disable */
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'Header',
        computed: {
            ...mapGetters([
                'get_steps', 'get_selected_building_slug', 'get_supplier', 'get_buildings'
            ]),
            supplierLogo () {
                return this.get_supplier.logo;
            }
        },
        methods: {
            prevStep () {
                switch (this.get_steps.current) {
                    case 1:
                        this.$router.push('/');
                        break;
                    case 2:
                        this.$router.push(`/${this.get_selected_building_slug}`);
                        break;
                    default:
                        this.$router.push(`/${this.get_selected_building_slug}/step-${(this.get_steps.current - 1)}`);
                }
            },
        },
    };

</script>



// WEBPACK FOOTER //
// src/components/modules/02_header/index.vue